import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Agendate from "./Componentes/Agendate";
import ZoneGestion1 from './Componentes/ZonasAplicacion/ZoneGestion1';
import ZoneGestion2 from './Componentes/ZonasAplicacion/ZoneGestion2';

const AgendatePrivateZone = () => {

    const navigate = useNavigate();

    const [modalInfo, setModalInfo] = useState(false)

    const [selectZoneRole, setSelectZoneRole] = useState('')

    const [userZoneProps, setUserZoneProps] = useState({
        tipoDeNegocio: '',
        tipoDeGestion: ''
    })

    useEffect(() => {
        let usuarioSessionStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioSessionStorage) {
            const usuarioSessionStorageObj = JSON.parse(usuarioSessionStorage)
            setSelectZoneRole(usuarioSessionStorageObj.role)
            setUserZoneProps({
                tipoDeNegocio: usuarioSessionStorageObj.tipoDeNegocio,
                tipoDeGestion: usuarioSessionStorageObj.tipoDeGestion
            })
        } else {
            setModalInfo(true)
        }
    }, [])

    const componentValidated = () => {
        switch (selectZoneRole) {
            case 'ROLE_ROOT':
                return (
                    <Agendate />
                )
            case 'ROLE_COMPANY_ADMIN':
                return zoneRoleCompanyAdmin()
            case 'ROLE_PROFESSIONAL':
                return (
                    <>ROLE_PROFESSIONAL</>
                )
            default:
                return (
                    <></>
                )
        }
    }

    const zoneRoleCompanyAdmin = () => {
        switch (userZoneProps.tipoDeGestion) {
            case 'GESTION_1':
                return (
                    <ZoneGestion1 tipoDeNegocio={userZoneProps.tipoDeNegocio} />
                )
            case 'GESTION_2':
                return (
                    <ZoneGestion2 tipoDeNegocio={userZoneProps.tipoDeNegocio} />
                )
            default:
                return (
                    <></>
                )
        }
    }

    const handleCloseInfo = () => {
        setModalInfo(false)
        navigate('/zona-agendate');
    };

    return (
        <>
            {
                componentValidated()
            }
            <Modal isOpen={modalInfo} onHide={handleCloseInfo} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Sesión requerida<FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Para continuar, es necesario iniciar sesión nuevamente.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseInfo}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default AgendatePrivateZone